document.documentElement.className = document.documentElement.className.replace('no-js', ''); //Remove no-js class ASAP

//For keeping track of product data
window.productJSON = [];
function addProductJSON(json) {
    window.productJSON.push(json);
}

//window.selectCallback is standard location for this function. Called whenever variant dropdown changes.
//Shopify's multi-currency code depends on it.
window.selectCallback = function(variant, selector){
  var $form = $(document.getElementById(selector.domIdPrefix)).closest('form');
  var $button = $form.find('input[type="submit"]');
  var $price = $form.closest('.detail').find('.price');
  //Update price & add-to-cart button states
  if(variant && variant.available == true) {
      $button.removeAttr('disabled');
      var priceHTML = Shopify.formatMoney(variant.price);
      if(variant.compare_at_price > variant.price) {
         priceHTML = '<span class="was-price">' + Shopify.formatMoney(variant.compare_at_price) + '</span>' + priceHTML;
      }
      $price.html(priceHTML);
  } else {
      $button.attr('disabled', 'disabled');
      $price.html(variant ? 'Sold out' : 'Unavailable');
  }
  
    //   Trigger Swym Variant event on change of dropdown.
  var swymButton = document.querySelectorAll('.swym-wishlist-quickview.swym-add-to-wishlist-view-product.product_'+$form.data('product-id'));  
  if(swymButton != undefined && swymButton != null && swymButton.length > 0){
  swymButton[0].setAttribute('data-variant-id', variant.id);
    }
  if(_swat){_swat.initializeActionButtons('.product-list')};

}
//Lightbox
var fbOpts = { overlayColor: '#fff', padding: 1, margin: 60, overlayOpacity: 0.9 };

/* Modernizr 2.6.2 (Custom Build) | MIT & BSD
 * Build: http://modernizr.com/download/#-csstransitions-input-testprop-testallprops-domprefixes-load
 */
;window.Modernizr=function(a,b,c){function w(a){i.cssText=a}function x(a,b){return w(prefixes.join(a+";")+(b||""))}function y(a,b){return typeof a===b}function z(a,b){return!!~(""+a).indexOf(b)}function A(a,b){for(var d in a){var e=a[d];if(!z(e,"-")&&i[e]!==c)return b=="pfx"?e:!0}return!1}function B(a,b,d){for(var e in a){var f=b[a[e]];if(f!==c)return d===!1?a[e]:y(f,"function")?f.bind(d||b):f}return!1}function C(a,b,c){var d=a.charAt(0).toUpperCase()+a.slice(1),e=(a+" "+m.join(d+" ")+d).split(" ");return y(b,"string")||y(b,"undefined")?A(e,b):(e=(a+" "+n.join(d+" ")+d).split(" "),B(e,b,c))}function D(){e.input=function(c){for(var d=0,e=c.length;d<e;d++)q[c[d]]=c[d]in j;return q.list&&(q.list=!!b.createElement("datalist")&&!!a.HTMLDataListElement),q}("autocomplete autofocus list placeholder max min multiple pattern required step".split(" "))}var d="2.6.2",e={},f=b.documentElement,g="modernizr",h=b.createElement(g),i=h.style,j=b.createElement("input"),k={}.toString,l="Webkit Moz O ms",m=l.split(" "),n=l.toLowerCase().split(" "),o={},p={},q={},r=[],s=r.slice,t,u={}.hasOwnProperty,v;!y(u,"undefined")&&!y(u.call,"undefined")?v=function(a,b){return u.call(a,b)}:v=function(a,b){return b in a&&y(a.constructor.prototype[b],"undefined")},Function.prototype.bind||(Function.prototype.bind=function(b){var c=this;if(typeof c!="function")throw new TypeError;var d=s.call(arguments,1),e=function(){if(this instanceof e){var a=function(){};a.prototype=c.prototype;var f=new a,g=c.apply(f,d.concat(s.call(arguments)));return Object(g)===g?g:f}return c.apply(b,d.concat(s.call(arguments)))};return e}),o.csstransitions=function(){return C("transition")};for(var E in o)v(o,E)&&(t=E.toLowerCase(),e[t]=o[E](),r.push((e[t]?"":"no-")+t));return e.input||D(),e.addTest=function(a,b){if(typeof a=="object")for(var d in a)v(a,d)&&e.addTest(d,a[d]);else{a=a.toLowerCase();if(e[a]!==c)return e;b=typeof b=="function"?b():b,typeof enableClasses!="undefined"&&enableClasses&&(f.className+=" "+(b?"":"no-")+a),e[a]=b}return e},w(""),h=j=null,e._version=d,e._domPrefixes=n,e._cssomPrefixes=m,e.testProp=function(a){return A([a])},e.testAllProps=C,e}(this,this.document),function(a,b,c){function d(a){return"[object Function]"==o.call(a)}function e(a){return"string"==typeof a}function f(){}function g(a){return!a||"loaded"==a||"complete"==a||"uninitialized"==a}function h(){var a=p.shift();q=1,a?a.t?m(function(){("c"==a.t?B.injectCss:B.injectJs)(a.s,0,a.a,a.x,a.e,1)},0):(a(),h()):q=0}function i(a,c,d,e,f,i,j){function k(b){if(!o&&g(l.readyState)&&(u.r=o=1,!q&&h(),l.onload=l.onreadystatechange=null,b)){"img"!=a&&m(function(){t.removeChild(l)},50);for(var d in y[c])y[c].hasOwnProperty(d)&&y[c][d].onload()}}var j=j||B.errorTimeout,l=b.createElement(a),o=0,r=0,u={t:d,s:c,e:f,a:i,x:j};1===y[c]&&(r=1,y[c]=[]),"object"==a?l.data=c:(l.src=c,l.type=a),l.width=l.height="0",l.onerror=l.onload=l.onreadystatechange=function(){k.call(this,r)},p.splice(e,0,u),"img"!=a&&(r||2===y[c]?(t.insertBefore(l,s?null:n),m(k,j)):y[c].push(l))}function j(a,b,c,d,f){return q=0,b=b||"j",e(a)?i("c"==b?v:u,a,b,this.i++,c,d,f):(p.splice(this.i++,0,a),1==p.length&&h()),this}function k(){var a=B;return a.loader={load:j,i:0},a}var l=b.documentElement,m=a.setTimeout,n=b.getElementsByTagName("script")[0],o={}.toString,p=[],q=0,r="MozAppearance"in l.style,s=r&&!!b.createRange().compareNode,t=s?l:n.parentNode,l=a.opera&&"[object Opera]"==o.call(a.opera),l=!!b.attachEvent&&!l,u=r?"object":l?"script":"img",v=l?"script":u,w=Array.isArray||function(a){return"[object Array]"==o.call(a)},x=[],y={},z={timeout:function(a,b){return b.length&&(a.timeout=b[0]),a}},A,B;B=function(a){function b(a){var a=a.split("!"),b=x.length,c=a.pop(),d=a.length,c={url:c,origUrl:c,prefixes:a},e,f,g;for(f=0;f<d;f++)g=a[f].split("="),(e=z[g.shift()])&&(c=e(c,g));for(f=0;f<b;f++)c=x[f](c);return c}function g(a,e,f,g,h){var i=b(a),j=i.autoCallback;i.url.split(".").pop().split("?").shift(),i.bypass||(e&&(e=d(e)?e:e[a]||e[g]||e[a.split("/").pop().split("?")[0]]),i.instead?i.instead(a,e,f,g,h):(y[i.url]?i.noexec=!0:y[i.url]=1,f.load(i.url,i.forceCSS||!i.forceJS&&"css"==i.url.split(".").pop().split("?").shift()?"c":c,i.noexec,i.attrs,i.timeout),(d(e)||d(j))&&f.load(function(){k(),e&&e(i.origUrl,h,g),j&&j(i.origUrl,h,g),y[i.url]=2})))}function h(a,b){function c(a,c){if(a){if(e(a))c||(j=function(){var a=[].slice.call(arguments);k.apply(this,a),l()}),g(a,j,b,0,h);else if(Object(a)===a)for(n in m=function(){var b=0,c;for(c in a)a.hasOwnProperty(c)&&b++;return b}(),a)a.hasOwnProperty(n)&&(!c&&!--m&&(d(j)?j=function(){var a=[].slice.call(arguments);k.apply(this,a),l()}:j[n]=function(a){return function(){var b=[].slice.call(arguments);a&&a.apply(this,b),l()}}(k[n])),g(a[n],j,b,n,h))}else!c&&l()}var h=!!a.test,i=a.load||a.both,j=a.callback||f,k=j,l=a.complete||f,m,n;c(h?a.yep:a.nope,!!i),i&&c(i)}var i,j,l=this.yepnope.loader;if(e(a))g(a,0,l,0);else if(w(a))for(i=0;i<a.length;i++)j=a[i],e(j)?g(j,0,l,0):w(j)?B(j):Object(j)===j&&h(j,l);else Object(a)===a&&h(a,l)},B.addPrefix=function(a,b){z[a]=b},B.addFilter=function(a){x.push(a)},B.errorTimeout=1e4,null==b.readyState&&b.addEventListener&&(b.readyState="loading",b.addEventListener("DOMContentLoaded",A=function(){b.removeEventListener("DOMContentLoaded",A,0),b.readyState="complete"},0)),a.yepnope=k(),a.yepnope.executeStack=h,a.yepnope.injectJs=function(a,c,d,e,i,j){var k=b.createElement("script"),l,o,e=e||B.errorTimeout;k.src=a;for(o in d)k.setAttribute(o,d[o]);c=j?h:c||f,k.onreadystatechange=k.onload=function(){!l&&g(k.readyState)&&(l=1,c(),k.onload=k.onreadystatechange=null)},m(function(){l||(l=1,c(1))},e),i?k.onload():n.parentNode.insertBefore(k,n)},a.yepnope.injectCss=function(a,c,d,e,g,i){var e=b.createElement("link"),j,c=i?h:c||f;e.href=a,e.rel="stylesheet",e.type="text/css";for(j in d)e.setAttribute(j,d[j]);g||(n.parentNode.insertBefore(e,n),m(c,0))}}(this,document),Modernizr.load=function(){yepnope.apply(window,[].slice.call(arguments,0))};

/*
* debouncedresize: special jQuery event that happens once after a window resize
*
* latest version and complete README available on Github:
* https://github.com/louisremi/jquery-smartresize/blob/master/jquery.debouncedresize.js
*
* Copyright 2011 @louis_remi
* Licensed under the MIT license.
*/
(function($) {
    var $event = $.event,
    $special,
    resizeTimeout;
    
    $special = $event.special.debouncedresize = {
        setup: function() {
            $( this ).on( "resize", $special.handler );
        },
        teardown: function() {
            $( this ).off( "resize", $special.handler );
        },
        handler: function( event, execAsap ) {
            // Save the context
            var context = this,
                args = arguments,
                dispatch = function() {
                    // set correct event type
                    event.type = "debouncedresize";
                    $event.dispatch.apply( context, args );
                };
    
            if ( resizeTimeout ) {
                clearTimeout( resizeTimeout );
            }
    
            execAsap ?
                dispatch() :
                resizeTimeout = setTimeout( dispatch, $special.threshold );
        },
        threshold: 200
    };
})(jQuery);
   
$(function(){
    //Return elements that have an ancestor/parent matching the supplied selector
    $.fn.hasAncestor = function(a) {
        return this.filter(function() {
            return $(this).closest(a).length > 0;
        });
    };
    
    //Side up and remove
    $.fn.slideUpAndRemove = function(speed){
        if(typeof speed == 'undefined') speed = 200;
        $(this).each(function(){
            $(this).slideUp(speed, function(){
                $(this).remove();
            });
        });
    }
    
    //Fade out image, replace src, fade back in when loaded
    $.fn.fadeToAnotherImage = function(newSrc, callback){
      var $img = $(this);
      if($img.attr('src') != newSrc) {
        $img.animate({opacity:0}, 200, function(){
          var oldHeight = $img.height();
          $img = $img.replaceImageWithOneOfNewSrc(newSrc);
          $img.css({ height: oldHeight, display: 'block' }); //Placeholder height until loaded. d:b required for occupying space in FF
          $img.imagesLoaded(function(){
            $img.css({height: '', display: ''}); //Revert to natural height
            $img.animate({opacity:1}, 200);
            if(callback) callback($img);
          });
        });
      }
      return $img;
    }
    
    $.fn.replaceImageWithOneOfNewSrc = function(newSrc) {
        //Used in a few places to avoid blank.gif breaking imagesLoaded
        var newTag = $(this).clone().wrap('<div />').parent().html();
        newTag = newTag.replace(/(src=")([^"]*)/gi, "$1" + newSrc);
        var $newTag = $(newTag);
        $(this).after($newTag).remove();
        return $newTag;
    }
    
    if(Modernizr.input.placeholder){
        //Placeholder text will vanish upon focus
        $('input[placeholder]').each(function(){
            $(this).data('placeholder', $(this).attr('placeholder'));
        });
        $(document).on('focusin', 'input[placeholder]', function(){
            $(this).attr('placeholder', '');
        }).on('focusout', 'input[placeholder]', function(){
            if($(this).val() == '' && typeof($(this).data('placeholder')) != 'undefined') {
                $(this).attr('placeholder', $(this).data('placeholder'));
            }
        });
    } else {
        //Simulate placeholder with JS
        $(document).on('focusin', 'input[placeholder]', function(){
            $(this).val('');
        }).on('focusout', 'input[placeholder]', function(){
            if($(this).val() == '' && typeof($(this).attr('placeholder')) != 'undefined') {
                $(this).val($(this).attr('placeholder'));
            }
        });
        $('input[placeholder]').trigger('focusout');
        $('input[placeholder]').parents('form').submit(function() {
            $(this).find('input[placeholder]').each(function() {
                var $input = $(this);
                if ($input.val() == $input.attr('placeholder')) {
                    $input.val('');
                }
            });
        });
    }
    
    /// Simple function to expand/contract a div
    $(document).on('click', 'a[data-toggle-target]', function(e){
        var $target = $($(this).data('toggle-target'));
        $(this).find('.state').html( $target.is(':visible') ? '+' : '-' );
        $target.slideToggle(200);
        e.preventDefault();
    });
    
    //Already visible? Set state
    $('a[data-toggle-target]').each(function(){
        var $target = $($(this).data('toggle-target'));
        $(this).find('.state').html( $target.is(':visible') ? '-' : '+' );
    });
    
    //Redirect dropdowns
    $(document).on('change', 'select.navdrop', function(){
        window.location = $(this).val();
    });
    
    //General purpose lightbox
  	$('a[rel="fancybox"]').fancybox($.extend({}, fbOpts, { titleShow: false }));
    
    /// NAV
    //Show expander plusses
  	$('.multi-level-nav ul li a').each(function(){
      var $siblingUL = $(this).siblings('ul');
      if($siblingUL.length > 0) {
        if($siblingUL.hasClass('listed')) {
          	$(this).addClass('listing-title');
        } else {
        	$(this).append('<span class="exp">+</span>');
        }
      }
  	});
  
    //Handle expanding nav
    var navAnimSpeed = 200;
    $(document).on('click', '.multi-level-nav a:has(.exp)', function(){
        //Set some useful vars
        var $tierEl = $(this).closest('[class^="tier-"]');
        var $tierCont = $tierEl.parent();
        var targetTierNum = parseInt($tierEl.attr('class').split('-')[1]) + 1;
        var targetTierClass = 'tier-' + targetTierNum;
        var $targetTierEl = $tierCont.children('.' + targetTierClass);
        
        ///Remove nav for all tiers higher than this one
        $tierCont.children().each(function(){
            if(parseInt($(this).attr('class').split('-')[1]) >= targetTierNum) {
                $(this).slideUpAndRemove(navAnimSpeed);
            }
        });
        
        //Are we expanding or collapsing
        if($(this).hasClass('expanded')) {
          //Collapsing. Reset state
          $(this).removeClass('expanded').find('.exp').html('+');
        } else {
          ///Show nav
          //Reset other nav items at this level
          $tierEl.find('a.expanded').removeClass('expanded').find('.exp').html('+');
          //If next tier div doesn't exist, make it
          if($targetTierEl.length == 0) {
            $targetTierEl = $('<div />').addClass(targetTierClass).appendTo($tierCont).hide();
          }
          $targetTierEl.empty().stop().append($(this).siblings('ul').clone()).slideDown(navAnimSpeed, function(){
            $(this).css('height', ''); //Clear height
          });
          //Mark as expanded
          $(this).addClass('expanded').find('.exp').html('-');
          
          //Scroll down if on a tiny screen
          if($tierCont.width() <= 768) {
            $('html:not(:animated),body:not(:animated)').animate({ scrollTop: $tierCont.offset().top }, 500 );
          }
        }
      
        return false;
    });
    
    //For all image fades
    var imageFadeInSpeed = 300;
    
    //Fade in images in product blocks
    $('.product-block .image-cont').each(function(){
        var $cont = $(this);
        $(this).find('img').imagesLoaded(function(){
            $cont.animate({opacity:1}, imageFadeInSpeed);
        });
    });
    
    //For fading in other images created by js
    function fadeInImageWhenReady($el, callback) {
        var $imgs = $el.is('img') ? $el : $el.find('img');
        $imgs.css('opacity', 0).imagesLoaded(function(){
            $imgs.animate({opacity: 1}, imageFadeInSpeed);
            if(callback) {
                callback();
            }
        });
    };
    
    //Enables any images inside a container
    function awakenImagesFromSlumber($cont) {
        $cont.find('img[data-src]').each(function(){
            $(this).replaceImageWithOneOfNewSrc($(this).data('src'));
        });
    };
    
    /// View modes for collection page
    $(document).on('click', '#view-as-tiles', function(){
        $(this).addClass('active');
        $('#view-as-stream').removeClass('active');
        var $listing = $('.collection-listing-stream').removeClass('collection-listing-stream').addClass('collection-listing');
        saveCollectionPageData();
        return false;
    });
    
    $(document).on('click', '#view-as-stream', function(){
        $(this).addClass('active');
        $('#view-as-tiles').removeClass('active');
        var $listing = $('.collection-listing').removeClass('collection-listing').addClass('collection-listing-stream');
        //All images enabled in this view (do before optionate, in case it switches images)
        awakenImagesFromSlumber($listing);
        //Close any open doodads & reset 'style=' styling to default
        $listing.find('.product-block').stop().each(function(){
            if($(this).hasClass('expanded')) {
                $(this).removeClass('expanded');
            }
            $(this).add($(this).find('.product-detail').stop()).removeAttr('style', '');
            $(this).find('select[name="id"]').trigger('optionate');
        });
        return false;
    });
    
    //If already in stream-mode, init product dropdowns
    $('.collection-listing-stream .product-block .product-detail').find('select[name="id"]').trigger('optionate');
    
    
    /// Collection-rows - show dropdown product detail
    function contractDetail($blocks) {
        if($blocks.length == 0) {
            if(typeof callback != 'undefined') callback();
        } else {
            $blocks.removeClass('expanded');
            $blocks.find('.product-detail').stop().animate({ height:0 }, droppyDownAnimSpeed);
            $blocks.stop().each(function(){
                $(this).animate({ paddingBottom: $(this).data('origPaddingBottom') }, droppyDownAnimSpeed);
            });
        }
    }
    
    function animateBlockHeight($block, heightToGetTo) {
        //Double padding on bottom, to mimic padding underneath block also being underneath detail
        $block.stop().animate({ paddingBottom:heightToGetTo + $block.data('origPaddingBottom')*3 }, droppyDownAnimSpeed);
        $block.find('.product-detail').stop().animate({ height:heightToGetTo }, droppyDownAnimSpeed);
    }
    
    var droppyDownAnimSpeed = 500;
    $(document).on('click', '.collection-listing:not(.related-tag) .product-block:not(.collection-block) .more-info', function(){
      var $block = $(this).closest('.product-block');
      var $slider = $(this).closest('.collection-slider');
      var pageWidth = $(window).width();
      //Only show dropdown if screen is large enough for it to be useful
      if(pageWidth > 480) {
        if($slider.length > 0) {
            //Inside a collection slider
            var $detailCont = $slider.closest('.collection-slider-row').find('.slider-collection-listing .product-detail');
            if($detailCont.length == 1) {
                if($block.hasClass('expanded')) {
                    //Just shrink it
                    $block.removeClass('expanded');
                    $detailCont.stop().animate({height: 0}, droppyDownAnimSpeed);
                } else {
                    //Unexpand others, reveal this
                    $('html:not(:animated),body:not(:animated)').animate({ scrollTop: $block.offset().top }, 500 );
                    var noneExpanded = $slider.find('.product-block.expanded').removeClass('expanded').length == 0;
                    if(noneExpanded) {
                        $detailCont.height(0);
                    }
                    $detailCont.html($block.children('.product-detail').html());
                    //Set close button data
                    $detailCont.find('.close-detail').data('block', $block);
                    awakenImagesFromSlumber($detailCont);
                    
                    //Event for when image size changes
                    var $inner = $detailCont.children('.inner');
                    $inner.unbind('changedsize').bind('changedsize', function(){
                        $detailCont.stop().animate({height: $detailCont.children('.inner').outerHeight()}, droppyDownAnimSpeed);
                    });
                    
                    //Init dropdowns
                    $detailCont.find('select[name="id"]').each(function(){
                        //Change dropdown ID so it remains unique
                        $(this).attr('id', $(this).attr('id') + '-slidedrop');
                    }).trigger('optionate');
                
                    //Adjust height
                    $inner.trigger('changedsize');
                    
                    fadeInImageWhenReady($inner, function(){
                        $inner.trigger('changedsize');
                    });
                    
                    $block.addClass('expanded');
                }
            }
        } else {
            //Normal collection page
            if($block.toggleClass('expanded').hasClass('expanded')) {
                //Expand this one
                
                //Contract neighbours
                contractDetail($block.siblings('.expanded'));
                
                $block.data('origPaddingBottom', parseInt($block.css('padding-bottom')));
                
                var $inner = $block.find('.product-detail > .inner');
                
                //Restore images
                awakenImagesFromSlumber($inner);
                
                //Init dropdowns (do after images init'd)
                $block.find('select[name="id"]').trigger('optionate');
                
                $inner.unbind('changedsize').bind('changedsize', function(){
                    //Check class in case slid-up before image loaded
                    if($block.hasClass('expanded')) {
                        animateBlockHeight($block, $inner.outerHeight());
                    }
                });
                
                //Slide down now
                $inner.trigger('changedsize');
                
                //Recalc height when images are loaded
                fadeInImageWhenReady($inner, function(){
                    $inner.trigger('changedsize');
                });
                
                
                //Scroll
                var offsetTop = typeof($block.data('offsetTop')) != 'undefined' ? $block.data('offsetTop') : $block.offset().top;
                $('html:not(:animated),body:not(:animated)').animate({ scrollTop: offsetTop }, 500 );
            } else {
                //Contract
                contractDetail($block);
            }
        }
        return false;
      }
    });
    
    //Close button event
    $(document).on('click', '.product-detail .close-detail', function(){
        $(this).data('block').find('.more-info:first').trigger('click');
        return false;
    });
    
    //You also need to know where to scroll to
    var $blocks = $('.collection-listing .product-block, .collection-listing-stream .product-block');
    function saveCollectionPageData() {
        var row = 0;
        var currTop = 0;
        //Heights are fixed. Check two in case somebody has expanded one...
        var blockHeight = Math.min($blocks.first().outerHeight(), $($blocks[1]).outerHeight());
        var blockPageOffset = $blocks.first().offset().top;
        $blocks.each(function(index){
            var currOffsetTop = $(this).offset().top;
            if(index == 0) {
                currTop = currOffsetTop;
            } else {
                if(currOffsetTop > currTop) {
                    row++;
                    currTop = currOffsetTop;
                }
            }
            $(this).data({
                offsetTop: blockPageOffset + row * blockHeight
            });
        });
    }
    if($blocks.length > 0) {
        $(window).on('debouncedresize', saveCollectionPageData);
        $('.collection-listing').imagesLoaded(saveCollectionPageData);
    }
    //End of code specific to collection-page slide-downs
    
    
    //For each product block in a listing
    $('.collection-listing .product-block, .collection-listing-stream .product-block').each(function(){
        //Add close button
        $('<a href="#" class="close-detail">X</a>').data('block', $(this)).appendTo($(this).find('.product-detail'));
    });
    
    
    /// Collection slider
    jQuery.fn.reverse = [].reverse; //Genius deserves credit: http://stackoverflow.com/questions/1394020/jquery-each-backwards
    
    $('.collection-slider').each(function(){
        var $nextPrevCont = $(this).find('.view-all');
        $(this).imagesLoaded(function(){
            $('<a class="prev" href="#">&larr;</a>').hide().prependTo($nextPrevCont).fadeIn().css('display', 'inline');
            $('<a class="next" href="#">&rarr;</a>').hide().appendTo($nextPrevCont).fadeIn().css('display', 'inline');
        });
    });
    $('.collection-slider').on('click', '.prev, .next', function(){
        //Find items visible in first row
        var showingNext = $(this).hasClass('next');
        var $items = $(this).closest('.collection-slider').find('.product-block');
        var $cont = $items.parent();
        var itemsToMove = [];
        var runningOffset = 0;
        if(showingNext) {
            //Next
            $items.each(function(index){
                if(index == 0) {
                    runningOffset = $(this).offset().top;
                    itemsToMove.push($(this));
                } else {
                    if($(this).offset().top == runningOffset) {
                        itemsToMove.push($(this));
                    } else {
                        return false; //Break loop
                    }
                }
            });
        } else {
            //Previous
            var contWidth = $cont.width();
            $items.reverse().each(function(){
                runningOffset += $(this).outerWidth();
                if(runningOffset <= contWidth) {
                    itemsToMove.push($(this));
                } else {
                    return false; //Break loop
                }
            });
        }
        //Fade out
        $items.stop().animate({opacity: 0}, 500, function(){
            //Rearrange
            $.each(itemsToMove, function(index, item){
                if(showingNext) {
                    $cont.append(item);
                } else {
                    $cont.prepend(item);
                }
            });
            //Fade in
            $items.stop().animate({opacity: 1}, 500);
        });
        return false;
    });
    
    /// Show lightbox for any shrunken images inside certain areas
    var imageKeys = ['_pico.','_icon.','_thumb.','_small.','_compact.','_medium.','_large.','_grande.'];
    $('.lightboximages img').each(function(){
        if(!$(this).parent().is('a')) {
            var imgurl = $(this).attr('src');
            for(var i = 0; i < imageKeys.length; i++) {
                if(imgurl.indexOf(imageKeys[i]) > -1) {
                    imgurl = imgurl.replace(imageKeys[i], '.');
                    break;
                }
            }
            var $wrapa = $('<a>').attr('href', imgurl).addClass('fancyboximg');
            $(this).wrap($wrapa);
            $(this).parent().fancybox(fbOpts);
        }
    });
    
    /// Galleries (inc. product page)
    $(document).on('click select', '.gallery .thumbnails a', function(){
      var newMainImageURL = $(this).attr('href');
      var $mainImageArea = $(this).closest('.gallery').find('.main-image');
      var $mainATag = $mainImageArea.find('a');
      //If this is a change in main image...
      if($mainATag.data('href') != $(this).data('full-size-url')) {
        //Set active class
        $(this).addClass('active').siblings().removeClass('active');
        //Set main image data - so we know which one is selected
        $mainATag.data('href', $(this).data('full-size-url'));
        //Set link if on product page - for lightbox
        if($mainATag.hasClass('shows-lightbox')) {
          $mainATag.attr('href', $(this).data('full-size-url'));
        }
        $mainImageArea.find('img').fadeToAnotherImage(newMainImageURL, function($img){
          $img.closest('.inner').trigger('changedsize');
        });
        //Pinterest button
        //var $pinBtn = $(this).closest('.product-detail').find('.pinterestcont > a');
// bug fix 5/20/2014 D.Davis
        var $pinBtn = $(this).closest('.product-detail').find('.pinterestcont > a[href]');
        if($pinBtn.length > 0) {
          var url = $pinBtn.attr('href');
          url = url.replace(/(media=)[^\&$]*/gi, '$1' + encodeURIComponent($(this).data('full-size-url')));
          $pinBtn.attr('href', url);
        }
      }
      return false;
    });
    
    /// Product variant selectors
    window.getVarOptToLink = function(prodId) {
        var optIdx = -1; //Invalid
        
        return optIdx;
    }
        
    $(document).on('optionate', 'select[name="id"]', function(){
        if(typeof $(this).data('optionated') == 'undefined') {
            $(this).data('optionated', true);
            var prodId = parseInt($(this).attr('id').split('-')[2]);
            for(var i=0; i<window.productJSON.length; i++) {
              	var prodJSON = window.productJSON[i];
                if(prodJSON.id == prodId) {
                    new Shopify.OptionSelectors($(this).attr('id'), { product: prodJSON, onVariantSelected: window.selectCallback });
                  	//Select first product in stock
                  	for(var j=0; j < prodJSON.variants.length; j++) {
                      var variant = prodJSON.variants[j];
                      if(variant.available) {
                        for(var k=0; k<variant.options.length; k++) {
                        	$('#product-select-'+prodJSON.id+'-option-'+k).val(variant.options[k]).trigger('change');
                        }
                        break;
                      }
                  	}
                    
                    break;
                }
            }
        }
    });
          
    //Default stream view - process dropdowns right away
    $('.collection-listing-stream select[name="id"]').trigger('optionate');
    
    
    
    /// Product page
    //Dropdowns
    $('#main-product-detail select[name="id"]').trigger('optionate');
    $('#main-product-detail').on('click', '.gallery .main-image a', function(){
        //Create list of imgs to box, so prev/next works
        var $thumbs = $(this).closest('.gallery').find('.thumbnails');
        if($thumbs.length > 0) {
            //Create dupes, rejig, launch matching link
            var $boxObjs = $thumbs.clone();
            $('body > .t-lightbox-thumbs').remove(); //Tidy
            $boxObjs.addClass('t-lightbox-thumbs').hide().appendTo('body').find('a').each(function(){
                $(this).attr('href', $(this).attr('data-full-size-url'));
            }).attr('rel', 'gallery').fancybox($.extend({}, fbOpts, { cyclic: true })).filter('[href="' + $(this).attr('href') + '"]').trigger('click');
        } else {
            //Create dupe of self and launch - thumbs may be hidden
            $(this).clone().fancybox($.extend({}, fbOpts, { cyclic: true })).trigger('click');
        }
        return false;
    });
    
    
    /// AJAX add to cart
    var cartPopupTemplate = [
        '<div id="cart-summary-overlay" class="cf">',
            '<div class="item">',
                '<div>'+"Just added:"+'</div>',
                '<div class="cols">',
                    '<div class="img"><img src="[[image_url]]" /></div>',
                    '<div class="info">',
                        '<div>[[title]]</div>',
                        '<div>[[price]]</div>',
                    '</div>',
                    '<div class="detail">',
                        '<div>'+"Qty"+' [[quantity]]</div>',
                        '<div>'+"Total"+' [[line_price]]</div>',
                    '</div>',
                '</div>',
            '</div>',
            '<div class="cart">',
                '<div>',
                    "Subtotal"+' <span>[[subtotal]]</span>',
                '</div>',
                '<div class="cart-text">'+"Excl. shipping"+'&nbsp;</div>',
                '<div>',
                    '<a id="shop-more" class="button altcolour" href="#">'+"Keep Shopping"+'</a>',
                    '<a class="button" href="/cart">'+"Cart"+'</a>',
                '</div>',
            '</div>',
        '</div>'
        ].join('');
    var shopifyAjaxAddURL = '/cart/add.js';
    var shopifyAjaxCartURL = '/cart.js';
    var shopifyAjaxStorePageURL = '/search';
    
    $(document).on('submit', 'form[action="/cart/add"]:not(.noAJAX)', function(e) {
        var $form = $(this);
        //Disable add button
        $form.find('input[type="submit"]').attr('disabled', 'disabled').each(function(){
            $(this).data('previous-value', $(this).val());
        }).val('Adding...');
        
        //Hide any existing notifications
        $('#cart-summary-overlay #shop-more').triggerHandler('click');
        
        //Add to cart
        $.post(shopifyAjaxAddURL, $form.serialize(), function(itemData) {
            //Enable add button
            $form.find('input[type="submit"]').removeAttr('disabled').each(function(){
                $btn = $(this);
                //Set to 'DONE', alter button style, wait a few secs, revert to normal
                $btn.val("Thank you!").addClass('inverted');
                window.setTimeout(function(){
                    $btn.removeClass('inverted').val($btn.data('previous-value'));
                }, 3000);
            });
            
            //Get our data
            var addedDataJSON = $.parseJSON(itemData);
            
            //Get current cart state
            $.get(shopifyAjaxCartURL, function(cartData){
                var cartDataJSON = $.parseJSON(cartData);
                var addedQty = parseInt($form.find('input[name="quantity"]').val());
                
                //Now we have all the data, build the shade
                var cartShadeHTML = cartPopupTemplate;
                cartShadeHTML = cartShadeHTML.replace('[[title]]', addedDataJSON.title);
                cartShadeHTML = cartShadeHTML.replace('[[quantity]]', addedQty);
                cartShadeHTML = cartShadeHTML.replace('[[image_url]]', addedDataJSON.image);
                cartShadeHTML = cartShadeHTML.replace('[[price]]', Shopify.formatMoney(addedDataJSON.price));
                cartShadeHTML = cartShadeHTML.replace('[[line_price]]', Shopify.formatMoney(addedDataJSON.price * addedQty));
                cartShadeHTML = cartShadeHTML.replace('[[subtotal]]', Shopify.formatMoney(cartDataJSON.total_price));
                
                var $cartShade = $(cartShadeHTML);
                $cartShade.find('#shop-more').bind('click', function(){
                    $cartShade.animate({top: - $cartShade.outerHeight()}, 500, function(){ $(this).remove(); });
                    return false;
                });
                $cartShade.prependTo('body').css('top', - $cartShade.outerHeight()).animate({top: 0}, 500);
              
				
                //Update currency of amount
              	Currency.convertAll(shopCurrency, jQuery('[name=currencies]').val());
                
            }, 'html');
            
            //Update header summary
            $.get(shopifyAjaxStorePageURL, function(data){
                var cartSummarySelector = '#pageheader .cart-summary .cart-count';
                var $newCartObj = $('<div>' + data + '</div>').find(cartSummarySelector);
                var $currCart = $(cartSummarySelector);
                $currCart.html($newCartObj.html());
            });
        }, 'text').error(function(data) {
            //Enable add button
            $form.find('input[type="submit"]').removeAttr('disabled').each(function(){
                $(this).val($(this).data('previous-value'));
            });
            
            //Not added, show message
            if(typeof(data) != 'undefined' && typeof(data.status) != 'undefined') {
                var jsonRes = $.parseJSON(data.responseText);
                window.showQuickPopup(jsonRes.description, $form.find('input[type="submit"]:first'));
            } else {
                //Some unknown error? Disable ajax and add the old-fashioned way.
                $form.addClass('noAJAX');
                $form.submit();
            }
        });
        return false;
    });
    $(window).scroll(function(){
        //Hide notifications on scroll
        $('#cart-summary-overlay #shop-more').triggerHandler('click');
    });
    
    
    //Show a quick generic text popup above an element
    window.showQuickPopup = function(message, $origin){
        var $popup = $('<div>').addClass('simple-popup');
        var offs = $origin.offset();
        $popup.html(message).css({ 'left':offs.left, 'top':offs.top }).hide();
        $('body').append($popup);
        $popup.css('margin-top', - $popup.outerHeight() - 10);
        $popup.fadeIn(200).delay(3500).fadeOut(400, function(){
            $(this).remove();
        });
    };
    
    //Start any slideshows on the page
    $('.flexslider').each(function(){
        $(this).flexslider({
            animation: 'slide',
            slideshow: $(this).hasClass('auto-play'),
            prevText: '&lsaquo;',
            nextText: '&rsaquo;',
            controlNav: false,
            slideshowSpeed: 7000 // Milliseconds to wait between slides
        });
    });
    
    //Quantity inputs - select when focus
    $(document).on('focusin click', 'input.select-on-focus', function(){
        $(this).select();
    }).on('mouseup', 'input.select-on-focus', function(e){
        e.preventDefault(); //Prevent mouseup killing select()
    });
    
    //Using JS in our forms?
    $('body').addClass('jsforms');
    $('#template').on('focusout keyup paste', 'input, textarea', function(){
        $('label[for="' + $(this).attr('id') + '"]').toggle($(this).val().length == 0);
    }).on('click', 'label', function(e){
        $('[id="' + $(this).attr('for') + '"]').focus();
    });
    
    //Shopify forms don't all have correct label attributes
    $('#template label').each(function(){
        var $sibinputs = $(this).siblings('input:not([type="submit"]), textarea');
        if($sibinputs.length == 1 && $sibinputs.attr('id').length > 0) {
            $(this).attr('for', $sibinputs.attr('id'));
        }
    });
    
    $(window).load(function(){
        //Show/hide labels
        $('#template input').trigger('keyup');
    });
    
    /// Main search input
    $('#pageheader .search-box input[type="text"]').bind('focusin focusout', function(e){
        $(this).closest('.search-box').toggleClass('focus', e.type == 'focusin');
    });
    
    /// Live search
    var preLoadLoadGif = $('<img src="//operadepot.com/cdn/shop/t/67/assets/ajax-load.gif?v=62939699503414190391769470589" />');
    var searchTimeoutThrottle = 500;
    var searchTimeoutID = -1;
    var currReqObj = null;
    var $resultsBox = $('<div class="results-box" />').appendTo('#pageheader .search-box');
    $('#pageheader .search-box input[type="text"]').bind('keyup change', function(){
        //Only search if search string longer than 2, and it has changed
        if($(this).val().length > 2 && $(this).val() != $(this).data('oldval')) {
            //Reset previous value
            $(this).data('oldval', $(this).val());
            
            // Kill outstanding ajax request
            if(currReqObj != null) currReqObj.abort();
            
            // Kill previous search
            clearTimeout(searchTimeoutID);
          
          	var $form = $(this).closest('form');
          
          	//Search term
          	var term = '*' + $form.find('input[name="q"]').val() + '*';
            
            //URL for full search page
            var linkURL = $form.attr('action') + '?type=product&q=' + term;
            
            //Show loading
            $resultsBox.html('<div class="load"></div>');
            
            // Do next search (in X milliseconds)
            searchTimeoutID = setTimeout(function(){
                //Ajax hit on search page
                currReqObj = $.ajax({
                  url: $form.attr('action'),
                  data: {
                    type: 'product',
                    view: 'json',
                    q: term,
                  },
                  dataType: "json",
                  success: function(data){
                        currReqObj = null;
                        if(data.results_total == 0) {
                            //No results
                            $resultsBox.html('<div class="note">'+ "No results found" +'</div>');
                        } else {
                            //Numerous results
                            $resultsBox.empty();
                            $.each(data.results, function(index, item){
                                var $row = $('<a></a>').attr('href', item.url);
                              	$row.append('<div class="img"><img src="' + item.thumb + '" /></div>');
                                $row.append(item.title);
                                $resultsBox.append($row);
                            });
                            $resultsBox.append('<a href="' + linkURL + '" class="note">See all results (' + data.results_total + ')</a>');
                        }
                  }
                });
            }, searchTimeoutThrottle);
        } else if ($(this).val().length <= 2) {
            //Deleted text? Clear results
            $resultsBox.empty();
        }
    }).attr('autocomplete', 'off').data('oldval', '').bind('focusin', function(){
        //Focus, show results
        $resultsBox.fadeIn(200);
    }).bind('click', function(e){
        //Click, prevent body from receiving click event
        e.stopPropagation();
    });
    $('body').bind('click', function(){
        //Click anywhere on page, hide results
        $resultsBox.fadeOut(200);
    });
    
    /// Collection page
    //If a tag is active in a group, other tags within that group must be links to that tag only, within that group.
    $('.multi-tag-row .tags').each(function(){
        var $active = $(this).find('li.active');
        $(this).find('li:not(.active) a').each(function(){
            var href = $(this).attr('href');
            $active.each(function(){
                var tag = $(this).data('tag');
                href = href.replace('+'+tag, '').replace(tag+'+', '');
            });
            $(this).attr('href', href);
        });
    });
     
     
     
     //Text that scales down - scale it up/down based on column width
     function resizeScalingTextFromColumn() {
       $('.scaled-text').each(function(){
         var $base = $(this).closest('.scaled-text-base');
         var scale = $base.width() / 1080;
         $(this).css('font-size', (scale * 100) + '%');
       });
     }
     resizeScalingTextFromColumn();
     $(window).on('debouncedresize', resizeScalingTextFromColumn);
      
     //Showing dropdown signup
     $('#pageheader .util-area .signup-reveal').bind('click', function(){
       $(this).parent().toggleClass('show-drop');
       return false;
     });
          
        /**** MailChimp Modal ****/		
        if ($.cookie("mailchimpmodal")) {
			// it hasn't been 14 days yet
		} else {
			// if the cookie is not set (or has expired and been removed)
			// set it again and then call the dialog for email signup
          $.cookie("mailchimpmodal", 1, { expires : 14, path: '/', domain: 'operadepot.com'  });

			setTimeout(function() {
					$('#newModal-test').modal('show').fadeIn(1000);
				}, 2000) // Display after 2 seconds.

		}
		ajaxMailChimpForm($("#subscribe-form"), $("#subscribe-result"));
		// Turn the given MailChimp form into an ajax version of it.
		// If resultElement is given, the subscribe result is set as html to
		// that element.
		function ajaxMailChimpForm($form, $resultElement) {
			// Hijack the submission. We'll submit the form manually.
			$form.submit(function(e) {
				e.preventDefault();
				if (!isValidEmail($form)) {
					var error = "A valid email address must be provided.";
					$resultElement.html(error);
					$resultElement.css("color", "red");
				} else {
					$resultElement.css("color", "black");
					$resultElement.html("Subscribing...");
					submitSubscribeForm($form, $resultElement);
				}
			});
		}

		// Validate the email address in the form

		function isValidEmail($form) {
				// If email is empty, show error message.
				// contains just one @
				var email = $form.find("input[type='email']").val();
				if (!email || !email.length) {
					return false;
				} else if (email.indexOf("@") == -1) {
					return false;
				}
				return true;
			}
			// Submit the form with an ajax/jsonp request.
			// Based on http://stackoverflow.com/a/15120409/215821

		function submitSubscribeForm($form, $resultElement) {
			$.ajax({
				type: "GET",
				url: $form.attr("action"),
				data: $form.serialize(),
				cache: false,
				dataType: "jsonp",
				jsonp: "c", // trigger MailChimp to return a JSONP response
				contentType: "application/json; charset=utf-8",
				error: function(error) {
					// According to jquery docs, this is never called for cross-domain JSONP requests
					$resultElement.html(error);
				},
				success: function(data) {
					if (data.result != "success") {
						var message = data.msg;
						$resultElement.css("color", "red");
						if (data.msg && data.msg.indexOf(
							"already subscribed") >= 0) {
							message =
								"You've already subscribed, but you can get your <a href=\"http://operadepot.com/pages/your-download\">free download here</a>.";
							$resultElement.css("color", "black");
							$('#subscribe-form').html(message);
						} else {
							$resultElement.html(message);
						}
					} else {
						$resultElement.css("color", "black");
						$('#subscribe-form').html(
							"Thanks for subscribing! Check your email to confirm<br>your subscription and get your free download."
						);
					}
				}
			});
		}
        /**** End of MailChimp Modal ****/
          
          
});


$(function(){
$('#main-nav a:contains("Our Collection")').trigger('click');
});
document.addEventListener("DOMContentLoaded", function() {
    // Function to update the audio source based on the selected variant
    function updateAudioSource(variant) {
        var sku = variant.sku;
        if (sku) {
            var audioUrl = 'https://s3.us-east-1.amazonaws.com/OD-Downloads/S' + sku + '.mp3';
            var audioPlayer = document.getElementById('audio');
            if(audioPlayer != null && audioPlayer != undefined){
          audioPlayer.src = audioUrl;
              }
        }
    }

    // Check if Shopify's variant selector script is present
    if (typeof Shopify !== 'undefined' && Shopify.OptionSelectors) {
        // Override the selectCallback function
        var originalSelectCallback = window.selectCallback;
        window.selectCallback = function(variant, selector) {
            if (variant) {
                updateAudioSource(variant);
            }
            if (typeof originalSelectCallback === 'function') {
                originalSelectCallback(variant, selector);
            }
        };
    } else {
        // For themes without Shopify.OptionSelectors
        document.querySelectorAll('select[name^="options"]').forEach(function(select) {
            select.addEventListener('change', function() {
                var selectedOptions = Array.from(document.querySelectorAll('select[name^="options"]')).map(function(select) {
                    return select.value;
                });
                var variant = product.variants.find(function(variant) {
                    return variant.options.every(function(option, index) {
                        return option === selectedOptions[index];
                    });
                });
                if (variant) {
                    updateAudioSource(variant);
                }
            });
        });
    }
});

/* ============================================================
   Customer Library Search — SPA SAFE (with delayed init retries)
   - Works on initial page load AND after SPA transitions
   - Enter-key search, multi-word tokens (AND match)
   - No re-rendering, just hides/shows existing .purchased-item cards
   ============================================================ */

(function () {
  // ---- configuration: how long we keep retrying after SPA nav ----
  const RETRY_EVERY_MS = 150;
  const RETRY_MAX_TRIES = 20; // 20 * 150ms = 3 seconds

  function normalize(str) {
    return (str || "")
      .toLowerCase()
      .replace(/[^\w\s]/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  function initCustomerLibrarySearch() {
    // Guard: only on the library page (elements must exist)
    const input = document.getElementById("keyword-search");
    const clearBtn = document.getElementById("clear-search");
    const items = Array.from(document.querySelectorAll(".purchased-item"));

    if (!input || !items.length) return false; // <-- IMPORTANT: return status

    // Prevent duplicate binding on the same DOM node
    if (input.dataset.bound === "1") return true;
    input.dataset.bound = "1";

    function runSearch(keyword) {
      const tokens = normalize(keyword).split(" ").filter(Boolean);

      items.forEach((el) => {
        const title = normalize(el.dataset.title);
        const match = tokens.length === 0 ? true : tokens.every((t) => title.includes(t));
        el.style.display = match ? "" : "none";
      });
    }

    // Enter key only
    input.addEventListener("keydown", (e) => {
      if (e.key !== "Enter") return;

      e.preventDefault();
      runSearch(input.value);

      if (clearBtn) {
        clearBtn.style.display = normalize(input.value) ? "block" : "none";
      }
    });

    // Clear search
    if (clearBtn) {
      clearBtn.addEventListener("click", () => {
        input.value = "";
        runSearch("");
        clearBtn.style.display = "none";
      });

      // Default hidden
      clearBtn.style.display = "none";
    }

    console.log("📚 Customer library search initialized");
    return true;
  }

  // Retry helper: keeps trying until the swapped DOM is actually present
  function initWithRetries() {
    let tries = 0;

    const tick = () => {
      tries += 1;

      const ok = initCustomerLibrarySearch();
      if (ok) return; // success

      if (tries < RETRY_MAX_TRIES) {
        setTimeout(tick, RETRY_EVERY_MS);
      } else {
        // Not an error — just means we're not on that page
        // or the markup never appeared.
        // console.log("📚 Library init gave up (not on page / DOM not present).");
      }
    };

    tick();
  }

  // ---- triggers (same intent as coming-soon) ----
  document.addEventListener("DOMContentLoaded", initWithRetries);
  document.addEventListener("shopify:page:load", initWithRetries);
  document.addEventListener("shopify:section:load", initWithRetries);
  document.addEventListener("od:after-swap", initWithRetries);

  // MutationObserver fallback (in case your SPA swap event doesn’t fire)
  let lastPath = location.pathname;
if (document.body instanceof Node) {
  new MutationObserver(() => {
    if (location.pathname !== lastPath) {
      lastPath = location.pathname;
      initWithRetries();
    }
  }).observe(document.body, { childList: true, subtree: true });
}


})();

/* ============================================================
   Customer Library Login Button — Legacy Theme Safe
   ============================================================ */

(function () {
  const RETRY_EVERY_MS = 150;
  const RETRY_MAX_TRIES = 20;

  function initLibraryLogin() {
    const btn = document.querySelector('[data-open-login]');
    if (!btn) return false;

    if (btn.dataset.bound === '1') return true;
    btn.dataset.bound = '1';

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      window.location.href = '/account/login?return_url=/pages/my-library';
    });

    console.log('🔐 Library login button initialized');
    return true;
  }

  function initWithRetries() {
    let tries = 0;

    const tick = () => {
      tries += 1;

      const ok = initLibraryLogin();
      if (ok) return;

      if (tries < RETRY_MAX_TRIES) {
        setTimeout(tick, RETRY_EVERY_MS);
      }
    };

    tick();
  }

  document.addEventListener('DOMContentLoaded', initWithRetries);
  document.addEventListener('shopify:section:load', initWithRetries);
})();
